import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import InputLockButton from 'components/desktop/_general/Input/InputExtensions/InputLockButton/InputLockButton';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import { Characteristic } from 'enums/characteristic';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const IngredientBaseIngredientOverwriteCard = ({
	state,
	handlers,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	const getLabelDensity = (): string => {
		return `${t('_general:DENSITY')} (${t('measurments:GRAMMS_PER_QUBIC_CM')})`;
	};

	const getLabelCalories = (): string => {
		if (state.characteristic === Characteristic.Fluid) {
			return `${t('_general:CALORIES')} (${t('measurments:CAL_PER_100_MILLILITERS')})`;
		} else {
			return `${t('_general:CALORIES')} (${t('measurments:CAL_PER_100_GRAMMS')})`;
		}
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="ingredient-overrides-card"
			title={t('ingredient:OVERRIDE_BASE_INGREDIENT')}
			content={
				<>
					<label>{getLabelDensity()}</label>
					<div className="input-group">
						<RoundedInput
							disabled={!isIngredientEditor || state.locked.density}
							error-key="Density"
							handleChange={handlers.setDensity}
							name="density"
							value={state.density ?? state.baseIngredientDensity}
						/>
						<InputLockButton
							isLocked={state.locked.density}
							onLockClick={(isLocked) =>
								isLocked
									? handlers.restoreBaseIngredientKey('density')
									: handlers.overwriteBaseIngredientKey('density')
							}
						/>
					</div>
					<label>{getLabelCalories()}</label>
					<div className="input-group">
						<RoundedInput
							disabled={!isIngredientEditor || state.locked.calories}
							error-key="Calories"
							handleChange={handlers.setCalories}
							name="calories"
							value={state.calories ?? state.baseIngredientCalories ?? 0}
						/>
						<InputLockButton
							isLocked={state.locked.calories}
							onLockClick={(isLocked) =>
								isLocked
									? handlers.restoreBaseIngredientKey('calories')
									: handlers.overwriteBaseIngredientKey('calories')
							}
						/>
					</div>
				</>
			}
		/>
	);
};
